import { Link, NavLink } from 'react-router-dom';
import styles from './Navbar.module.css';
import { useState } from 'react';
const Navbar = (): JSX.Element => {
  const [active, setActive] = useState<boolean>(false);
  return (
    <div className={styles.navbar}>
      <Link to="../" className={styles.title}>
        QC
      </Link>
      <div className={`${styles.pages} ${active ? styles.activePages : ''}`}>
        <NavLink
          className={({ isActive }) =>
            isActive
              ? `${styles.linkOptions}`
              : `${styles.linkOptionsUnselected}`
          }
          to="/research"
          onClick={() => {
            setActive(false);
          }}
        >
          <div className={styles.pageText}> Research</div>
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            isActive
              ? `${styles.linkOptions}`
              : `${styles.linkOptionsUnselected}`
          }
          to="/about"
          onClick={() => {
            setActive(false);
          }}
        >
          <div className={styles.pageText}> About</div>
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            isActive
              ? `${styles.linkOptions}`
              : `${styles.linkOptionsUnselected}`
          }
          to="/contact"
          onClick={() => {
            setActive(false);
          }}
        >
          <div className={styles.pageText}>Contact</div>
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            isActive
              ? `${styles.linkOptions}`
              : `${styles.linkOptionsUnselected}`
          }
          to="/tools"
          onClick={() => {
            setActive(false);
          }}
        >
          {' '}
          <div className={styles.pageText}>Tools</div>
        </NavLink>
      </div>
      <div
        className={`${styles.hamburger} ${
          active ? styles.activeHamburger : ''
        }`}
        onClick={() => {
          setActive(!active);
        }}
      >
        <span className={styles.bar}></span>
        <span className={styles.bar}></span>
        <span className={styles.bar}></span>
      </div>
    </div>
  );
};

export default Navbar;
